import type { CurrentUserResponseData } from 'gcs-common/clients/api/entities/current-user/current-user-api';
import moment from 'moment';

enum ONLINE_STATUS {
  ONLINE = 'ONLINE',
  IDLE = 'IDLE',
  OFFLINE = 'OFFLINE',
  UNKNOWN = 'UNKNOWN',
}

const AGENT_STATUS_TEXT = {
  [ONLINE_STATUS.ONLINE]: 'Aktiv',
  [ONLINE_STATUS.IDLE]: 'In Kürze verfügbar',
  [ONLINE_STATUS.OFFLINE]: 'Inaktiv',
  [ONLINE_STATUS.UNKNOWN]: 'Status unbekannt',
} as const;

const ONLINE_STATUS_PRIORITY = {
  [ONLINE_STATUS.ONLINE]: 1,
  [ONLINE_STATUS.IDLE]: 2,
  [ONLINE_STATUS.OFFLINE]: 3,
  [ONLINE_STATUS.UNKNOWN]: 4,
  undefined: 5,
} as const;

const buildAgentStatus = ({ statusType }: { statusType: ONLINE_STATUS }) => {
  return {
    type: statusType,
    text: AGENT_STATUS_TEXT[statusType],
    updatedAt: moment().format(),
  };
};

const calculateUserStatus = (isConnected: boolean, user: CurrentUserResponseData, ignoreConnectionStatus = false) => {
  const unknownStatus: CurrentUserResponseData['status'] = {
    type: ONLINE_STATUS.UNKNOWN,
    text: 'Status unbekannt',
  };

  // ignore connection status for checking if a sales space is free to avoid channel list flickering
  if ((!isConnected && !ignoreConnectionStatus) || !user || !user.userType) {
    return unknownStatus;
  }

  const { status } = user;
  if (status) {
    return status;
  }
  return unknownStatus;
};

export { AGENT_STATUS_TEXT, buildAgentStatus, calculateUserStatus, ONLINE_STATUS, ONLINE_STATUS_PRIORITY };
